<template>
    <div>
        <div class="product-listing__header">
            <div
                v-if="Object.keys(attributes).length > 0 && attrShow.length > 0"
                class="product-listing__header-options-wrapper product-listing__header-options-wrapper--left"
            >
                <template v-for="(item, key) in filteredFinal">
                    <div
                        v-if="item.length"
                        :key="key"
                        class="product-listing__header-options-outer"
                    >
                        <div
                            v-if="key === 'pa_material'"
                            class="product-listing__header-options--with-img-container"
                        >
                            <CustomSelect
                                :image="true"
                                :item="item"
                                :filterTerms="filterTerms"
                                v-on:setAttrOnClick="setAttrOnClick"
                                v-on:removeAttr="removeAttr"
                            />
                        </div>
                        <div
                            v-else
                            class="product-listing__header-options-container"
                        >
                            <CustomSelect
                                :image="false"
                                :item="item"
                                :filterTerms="filterTerms"
                                v-on:setAttrOnClick="setAttrOnClick"
                                v-on:removeAttr="removeAttr"
                            />
                        </div>
                    </div>
                </template>
                <div class="product-listing__header-btn-wrapper">
                    <a
                        class="product-listing__header-btn"
                        v-if="checkIfEmpty(selectedAttributes)"
                        @click="resetFilter()"
                        href="javascript:;"
                        >Clear Filters</a
                    >
                </div>
            </div>
            <div
                class="product-listing__header-options-wrapper product-listing__header-options-wrapper--right"
            >
                <div class="product-listing__header-options-container">
                    <span
                        class="product-listing__header-options-container-title"
                        >Sort by:</span
                    >
                    <VueSelect
                        @input="setSortval"
                        :value="setValueSelect()"
                        :label="orderOption.label"
                        :options="orderOption"
                        placeholder="Default (Catalog)"
                        :searchable="false"
                    ></VueSelect>
                </div>
            </div>
        </div>
        <!-- .product-listing__header -->
        <div
            class="product-listing__pagination-wrapper"
            v-show="(products && products.length) || !isInitialFetch"
        >
            <div class="product-listing__pagination-view-per-page">
                <span
                    class="product-listing__pagination-view-text"
                    v-show="products.length"
                    >Viewing
                    <span>{{ calculateRange(page, limit, ids.length) }} </span
                    >of {{ ids.length }}
                    products.
                </span>
<!--                <div class="product-listing__pagination-view-select-box">
                    <span
                        v-show="itemsPerPage.length"
                        class="product-listing__pagination-view-select-box-text"
                        >Showing items per page:
                        <span class="product-listing__pagination-view-select">
                            <VueSelect
                                @input="setPerPageVal"
                                :value="perPageVal.val"
                                :label="itemsPerPage.label"
                                :options="itemsPerPage"
                                :searchable="false"
                            ></VueSelect>
                        </span>
                    </span>
                </div>-->
            </div>
            <div class="product-listing__pagination">
                <ul class="pagination-list" v-show="lastPage > 1">
                    <li>
                        <a class="" @click="fetchPaginatedData(page - 1)">«</a>
                    </li>
                    <li v-for="pageNumber in paginationArray" :key="pageNumber">
                        <a
                            :class="{
                                active: pageNumber === page,
                                dots: isNaN(pageNumber)
                            }"
                            @click="
                                paginationAllowed(pageNumber) &&
                                !fetchInProgress
                                    ? fetchPaginatedData(pageNumber)
                                    : null
                            "
                            >{{ pageNumber }}</a
                        >
                    </li>
                    <li><a @click="fetchPaginatedData(page + 1)">»</a></li>
                </ul>
            </div>
        </div>

        <Product
            ref="product"
            :btn="$refs.btnHide"
            :products="products"
            :favorites="favorites"
            :productWishlist="productWishlist"
            :wishlist="wishlist"
            :addToCartLoading="addToCartLoading"
            :curentCount="curentCount"
            :cart="cart"
            v-on:addToCompare="addToCompare"
        />

        <div
            class="product-listing__not-found-wrapper"
            v-if="products && products.length === 0 && !fetchInProgress"
        >
            <div class="product-listing__not-found">
                <img
                    class="product-listing__not-found-img"
                    :src="
                        kadraGlobal.icons + '/src/assets/images/no-product.png'
                    "
                    alt=""
                />
                <span class="product-listing__not-found-title"
                    >No products found.</span
                >
                <p class="product-listing__not-found-text">
                    Your search did not match any products.
                </p>
                <p class="product-listing__not-found-text">
                    Please try another search or go back to homepage.
                </p>
                <a class="product-listing__not-found-link" href="/"
                    ><svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                    >
                        <!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
                        <path
                            d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288 480 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-370.7 0 73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-128 128z"
                        /></svg
                    >Back to homepage</a
                >
            </div>
        </div>

        <!-- added product-listing__pagination-wrapper--bottom class for the padding difference -->
        <div
            class="product-listing__pagination-wrapper product-listing__pagination-wrapper--bottom"
            v-show="products && products.length && !isInitialFetch"
        >
            <div class="product-listing__pagination-view-per-page">
                <span class="product-listing__pagination-view-text"
                    >Viewing
                    <span>{{ calculateRange(page, limit, ids.length) }} </span
                    >of {{ ids.length }}
                    products.
                </span>
<!--                <div class="product-listing__pagination-view-select-box">
                    <span
                        v-show="itemsPerPage.length"
                        class="product-listing__pagination-view-select-box-text"
                        >Showing items per page:
                        <span class="product-listing__pagination-view-select">
                            <VueSelect
                                @input="setPerPageVal"
                                :value="perPageVal.val"
                                :label="itemsPerPage.label"
                                :options="itemsPerPage"
                                :searchable="false"
                            ></VueSelect>
                        </span>
                    </span>
                </div>-->
            </div>
            <div class="product-listing__pagination">
                <ul class="pagination-list" v-show="lastPage > 1">
                    <li>
                        <a class="" @click="fetchPaginatedData(page - 1)">«</a>
                    </li>
                    <li v-for="pageNumber in paginationArray" :key="pageNumber">
                        <a
                            :class="{
                                active: pageNumber === page,
                                dots: isNaN(pageNumber)
                            }"
                            @click="
                                paginationAllowed(pageNumber)
                                    ? fetchPaginatedData(pageNumber)
                                    : null
                            "
                            >{{ pageNumber }}</a
                        >
                    </li>
                    <li><a @click="fetchPaginatedData(page + 1)">»</a></li>
                </ul>
            </div>
        </div>

        <div
            v-if="compare.length !== 0"
            :class="{
                'product-listing__comapre-wrapper product-listing__comapre-wrapper--open': compareClass,
                'product-listing__comapre-wrapper product-listing__comapre-wrapper--collapsed': !compareClass
            }"
        >
            <a
                href="javascript:;"
                class="product-listing__comapre-btn product-listing__comapre-btn--collapse js-comapre-collapse"
                @click="compareToggle()"
                ><span
                    :class="{
                        'product-listing__comapre-btn-collapse-icon': compareClass,
                        'product-listing__comapre-btn-collapse-icon product-listing__comapre-btn-collapse-icon--up': !compareClass
                    }"
                ></span
            ></a>
            <a
                href="javascript:;"
                class="product-listing__comapre-btn product-listing__comapre-btn--close js-comapre-close"
                @click="removeAllFromCompare()"
                ><span class="product-listing__comapre-btn-close-icon"></span
            ></a>
            <div
                class="product-listing__compare-title-wrap"
                @click="compareToggle()"
            >
                <span class="product-listing__compare-title">COMPARE</span>
            </div>
            <div class="container product-listing__compare-wrap">
                <div class="product-listing__compare-container">
                    <div class="product-listing__comapre-products">
                        <div
                            v-for="product in compare"
                            :key="product.id"
                            class="product-listing__comapre-product"
                        >
                            <span
                                class="product-listing__compare-close"
                                @click="removeCompare(product)"
                            ></span>
                            <div class="product-listing__comapre-product-img">
                                <img
                                    :src="
                                        product.thumb ||
                                            kadraGlobal.icons +
                                                '/src/assets/images/plch.jpg'
                                    "
                                    alt=""
                                />
                            </div>
                            <span
                                class="product-listing__comapre-product-title"
                                v-html="product.title"
                            ></span>
                        </div>
                        <div
                            v-for="emptyComp in emptyCompare"
                            :key="emptyComp"
                            class="product-listing__comapre-product product-listing__comapre-product--empty"
                        >
                            <span>Select product for compare</span>
                        </div>
                    </div>
                    <!-- .product-listing__wrapper -->
                    <a
                        :class="{
                            'btn single-product__compare-btn':
                                compare.length >= 2,
                            'btn single-product__compare-btn-disable':
                                compare.length <= 1
                        }"
                        @click="checkCompare()"
                        href="javascript:;"
                        >Compare</a
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Product from './Product.vue';
import CustomSelect from './CustomSelect.vue';
import VueSelect from 'vue-select';
import { mapState } from 'vuex';

export default {
    components: {
        Product,
        VueSelect,
        CustomSelect
    },
    props: [
        'curentCount',
        'kadraGlobal',
        'favorites',
        'productWishlist',
        'wishlist',
        'addToCartLoading',
        'cart',
        'filterTerms'
    ],
    data() {
        return {
            compare: [],
            filteredFinal: {},
            emptyCompare: 3,
            compareClass: false,
            paginationArray: [],
            orderOption: [
                {
                    label: 'Default (Catalog)',
                    val: 'featured'
                },
                {
                    label: 'Price: Low to High',
                    val: 'min_price'
                },
                {
                    label: 'Price: High to Low',
                    val: 'max_price'
                },
                {
                    label: 'Newest',
                    val: 'new'
                },
                {
                    label: 'Oldest',
                    val: 'old'
                }
            ],
            itemsPerPageDefault: [
                {
                    label: '25',
                    val: '25'
                },
                {
                    label: '50',
                    val: '50'
                },
                {
                    label: '75',
                    val: '75'
                },
                {
                    label: '100',
                    val: '100'
                }
            ],
            itemsPerPage: []
        };
    },
    watch: {
        compareClass() {
            this.$emit('compareView', this.compareClass);
        },
        filteredAttributes() {
            this.fillAttrs();
        },
        page() {
            this.paginationArray = this.generatePaginationArray(
                this.page,
                this.lastPage,
                7,
                '...'
            );
        },
        lastPage() {
            this.paginationArray = this.generatePaginationArray(
                this.page,
                this.lastPage,
                7,
                '...'
            );
        },
        ids() {
            /*const newItemsPerPage = [];

            if (!this.ids?.length) {
                return (this.itemsPerPage = newItemsPerPage);
            }

            const idsLength = this.ids.length;

            if (idsLength <= 25) {
                newItemsPerPage.push({ label: '25', val: '25' });
            } else if (idsLength <= 50) {
                newItemsPerPage.push(
                    { label: '25', val: '25' },
                    { label: '50', val: '50' }
                );
            } else if (idsLength <= 75) {
                newItemsPerPage.push(
                    { label: '25', val: '25' },
                    { label: '50', val: '50' },
                    { label: '75', val: '75' }
                );
            } else {
                newItemsPerPage.push(
                    { label: '25', val: '25' },
                    { label: '50', val: '50' },
                    { label: '75', val: '75' },
                    { label: '100', val: '100' }
                );
            }
            const lastItemVal = parseInt(
                newItemsPerPage[newItemsPerPage.length - 1].val
            );
            const perPageVal = parseInt(this.perPageVal.val);

            if (lastItemVal < perPageVal) {
                this.setPerPageVal(newItemsPerPage[newItemsPerPage.length - 1]);
            }
            this.itemsPerPage = newItemsPerPage;*/
        }
    },
    computed: {
        ...mapState({
            isLastPage: state => state.Listing.isLastPage,
            page: state => state.Pagination.page,
            sort: state => state.Pagination.sort,
            lastPage: state => state.Pagination.lastPage,
            ids: state => state.Listing.ids,
            attrShow: state => state.Listing.attrShow,
            attributes: state => state.Listing.attributes,
            products: state => state.Listing.products,
            filters: state => state.Pagination.filters,
            selectedAttributes: state => state.Pagination.selectedAttributes,
            filteredAttributes: state => state.Listing.filteredAttributes,
            fetchInProgress: state => state.Pagination.fetchInProgress,
            isInitialFetch: state => state.Pagination.isInitialFetch,
            limit: state => state.Pagination.limit
        }),
        perPageVal: {
            get() {
                return {
                    val: this.limit.toString(),
                    label: this.limit.toString()
                };
            },
            async set(val) {
                await this.$store.dispatch('setLimit', parseInt(val.val));
            }
        }
    },
    methods: {
        calculateRange(currentPage, productsPerPage, totalProducts) {
            const startIndex = (currentPage - 1) * productsPerPage + 1;
            let endIndex = startIndex + productsPerPage - 1;
            endIndex = Math.min(endIndex, totalProducts);

            const displayRange = `${startIndex} - ${endIndex}`;
            return displayRange;
        },
        paginationAllowed(toTest) {
            return !isNaN(toTest);
        },
        generatePaginationArray(
            currentPage,
            totalPages,
            maxVisiblePages = 7,
            ellipsisSymbol = '...'
        ) {
            if (!currentPage || !totalPages) return [];
            const ellipsisSymbolWithZeroWidthSpace = ellipsisSymbol + '\u200B';
            const sanitizedMaxVisiblePages = Math.max(maxVisiblePages, 7);
            const paginationArray = [];

            if (totalPages <= sanitizedMaxVisiblePages) {
                for (let i = 1; i <= totalPages; i++) {
                    paginationArray.push(i);
                }
            } else {
                const showBothEllipsisThreshold =
                    Math.floor(sanitizedMaxVisiblePages / 2) - 1;
                const showRightEllipsisThreshold = Math.ceil(
                    sanitizedMaxVisiblePages / 2
                );
                const totalPagesSubtraction = Math.ceil(
                    sanitizedMaxVisiblePages / 2
                );

                if (currentPage <= showRightEllipsisThreshold) {
                    for (let i = 1; i <= sanitizedMaxVisiblePages - 2; i++) {
                        paginationArray.push(i);
                    }
                    paginationArray.push(ellipsisSymbolWithZeroWidthSpace);
                    paginationArray.push(totalPages);
                } else if (
                    currentPage > showBothEllipsisThreshold &&
                    currentPage <= totalPages - totalPagesSubtraction
                ) {
                    const middleCount = sanitizedMaxVisiblePages - 4;
                    paginationArray.push(1);
                    paginationArray.push(ellipsisSymbol);
                    for (
                        let i = currentPage - Math.floor(middleCount / 2);
                        i <= currentPage + Math.floor(middleCount / 2);
                        i++
                    ) {
                        paginationArray.push(i);
                    }
                    paginationArray.push(ellipsisSymbolWithZeroWidthSpace);
                    paginationArray.push(totalPages);
                } else {
                    paginationArray.push(1);
                    paginationArray.push(ellipsisSymbol);
                    for (
                        let i = totalPages - sanitizedMaxVisiblePages + 3;
                        i <= totalPages;
                        i++
                    ) {
                        paginationArray.push(i);
                    }
                }
            }
            return paginationArray;
        },
        fillAttrs() {
            Object.keys(this.attributes).forEach(key => {
                if (this.attrShow.includes(key)) {
                    const attributesIds = this.attributes[key].map(
                        x => x.term_id
                    );
                    const filteredAttributesIds = this.filteredAttributes[
                        key
                    ].map(x => x);
                    const commonIds = attributesIds.filter(termId =>
                        filteredAttributesIds.includes(termId)
                    );
                    this.filteredFinal[key] = this.attributes[key].filter(x =>
                        commonIds.includes(x.term_id)
                    );
                }
            });
        },
        checkIfEmpty(obj) {
            if (typeof obj === 'object') {
                if (Object.keys(obj).length > 0) {
                    return true;
                }
            } else {
                if (obj.length > 0) {
                    return true;
                }
            }
            return false;
        },
        compareToggle() {
            this.compareClass = !this.compareClass;
        },
        async setPerPageVal(val) {
            this.perPageVal = val;
            await this.$store.dispatch('setLimit', parseInt(val.val));
            this.setSortval({ val: this.filters.sort });
        },
        async setSortval(value) {
            if (!this.products.length) {
                return;
            }
            await this.$store.dispatch('setFilters', {
                ...this.filters,
                sort: value.val ? value.val : 'featured',
                page: 1,
                shouldFetch: true
            });
        },
        setValueSelect() {
            switch (this.filters.sort) {
                case 'featured':
                    return 'Default (Catalog)';
                case 'new':
                    return 'Newest';
                case 'old':
                    return 'Oldest';
                case 'min_price':
                    return 'Price: Low to High';
                case 'max_price':
                    return 'Price: High to Low';
                default:
                    return 'Newest';
            }
        },
        async setAttrOnClick(term) {
            const newAttributes = this.getCheckedAttributes(true, term);
            await this.$store.dispatch('setSelectedAttributes', newAttributes);
            await this.$store.dispatch('setFilters', {
                ...this.filters,
                [term.taxonomy]: term.term_id,
                page: 1,
                shouldFetch: true
            });
        },
        getIdsPerPage(ids, page) {
            const limit = this.limit;
            const startIndex = (page - 1) * limit;
            const endIndex = startIndex + limit;

            if (startIndex < 0) {
                return [];
            }

            return ids.slice(startIndex, endIndex);
        },
        checkArr(term) {
            this.$emit('changeAttr', term.taxonomy, term.term_id);
        },
        async removeAttr(term) {
            const newAttributes = this.getCheckedAttributes(false, term);
            await this.$store.dispatch('setSelectedAttributes', newAttributes);
            await this.$store.dispatch('setFilters', {
                ...this.filters,
                [term.taxonomy]: '',
                page: 1,
                shouldFetch: true
            });
        },
        async resetFilter() {
            if (this.fetchInProgress) return;
            this.$emit('resetFilters');
            await this.$store.dispatch('setFilters', {
                pa_brand: '',
                pa_color: '',
                pa_material: '',
                sort: '',
                cat: '',
                page: 1,
                shouldFetch: true
            });
        },
        getCheckedAttributes(add, term) {
            const checkedAttributes = this.selectedAttributes;
            if (add) {
                checkedAttributes[term.taxonomy] = term.term_id;
            } else {
                delete checkedAttributes[term.taxonomy];
            }
            return checkedAttributes;
        },
        addToCompare(compare) {
            if (compare.length === 4) {
                compare.splice(0, 1);
            }
            this.setEmptyCompare(compare);
            this.setCompareToLocalStorage(compare);
            this.compareClass = true;
        },
        setCompareToLocalStorage(compare) {
            localStorage.setItem(
                'compare-' + this.kadraGlobal.userId,
                JSON.stringify(compare)
            );
            this.compare = compare;
        },
        setEmptyCompare(compare) {
            this.emptyCompare = 3 - compare.length;
        },
        removeCompare(product) {
            const index = this.compare.findIndex(obj => obj.id === product.id);
            this.compare.splice(index, 1);
            localStorage.setItem(
                'compare-' + this.kadraGlobal.userId,
                JSON.stringify(this.compare)
            );
        },
        removeAllFromCompare() {
            this.compareClass = false;
            this.compare = [];
            localStorage.setItem(
                'compare-' + this.kadraGlobal.userId,
                JSON.stringify(this.compare)
            );
            this.$refs.product.removeAllCompare();
        },
        checkCompare() {
            if (this.compare.length >= 2) {
                window.location.href = kadraGlobal.Url + '/compare';
            }
        },
        isFooterPresent(el) {
            const rect = el.getBoundingClientRect();
            return (
                rect.bottom > 0 &&
                rect.top <
                    (window.innerHeight ||
                        document.documentElement.clientHeight)
            );
        },
        async fetchPaginatedData(page) {
            if (page < 1 || page > this.lastPage || this.fetchInProgress)
                return;
            await this.$store.dispatch('setFetchInProgress', true);
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
            await this.$store.dispatch('resetProducts');
            await this.$store.dispatch('fetchProducts', {
                page: page,
                ids: this.getIdsPerPage(this.ids, page),
                type: 'pagination'
            });
            await this.$store.dispatch('setFetchInProgress', false);
        }
    }
};
</script>

<style lang="scss" scoped>
.product-listing__header {
    margin-bottom: 0;

    @include mq($xl) {
        flex-direction: column;
    }
}

.product-listing__header-btn-wrapper {
    height: 67px;
    margin-bottom: 25px;
    display: flex;
    justify-content: center;
    align-items: center;

    @include mq(1500px) {
        @include mq(1025px, min) {
            max-width: 17%;
        }
    }

    @include mq(1024px) {
        max-width: 48.5%;
        width: 100%;
        justify-content: flex-start;
    }

    @include mq($lg) {
        height: 94px;
        padding-bottom: 20px;
    }

    @include mq($md) {
        padding-bottom: 0;
        max-width: 100% !important;
        height: auto;
        justify-content: flex-end;
    }
}

//sass-lint:disable-line no-important
.product-listing__header-btn {
    color: $theme-green;
    font-size: 16px;
    font-weight: 600;
    font-family: $font-second;
    position: relative;
    transition: $dur $ease;
    padding-left: 25px;

    &:hover {
        transition: $dur $ease;
        color: $yellow;

        &::before {
            opacity: 0;
            transition: $dur $ease;
        }

        &::after {
            opacity: 1;
            transition: $dur $ease;
        }
    }

    &::before,
    &::after {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        height: 19px;
        transition: $dur $ease;
        width: 17px;
    }

    &::before {
        content: url('data:image/svg+xml;charset=UTF-8, <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500" fill="rgba(0, 190, 157, 1)"><path d="M486.3 267.6L332 421.9h156.3c3.3 0 6 1.1 8.3 3.4s3.4 5 3.4 8.3V457c0 3.3-1.1 6-3.4 8.3s-5 3.4-8.3 3.4H140.6c-13 0-24.1-4.6-33.2-13.7l-93.8-93.8c-9-9-13.6-20.1-13.6-33.1s4.6-24.1 13.7-33.2l250-250c9.1-9.1 20.2-13.7 33.2-13.7s24.1 4.6 33.2 13.7l156.3 156.3c9.1 9.1 13.7 20.2 13.7 33.2s-4.7 24.1-13.8 33.2zM140.6 421.9h125l53.7-53.7-156.2-156.3L46.9 328.1l93.7 93.8zM296.9 78.1L196.3 178.7 352.5 335l100.6-100.6L296.9 78.1z"/></svg>');
    }

    &::after {
        content: url('data:image/svg+xml;charset=UTF-8, <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500" fill="rgba(240, 194, 1, 1)"><path d="M486.3 267.6L332 421.9h156.3c3.3 0 6 1.1 8.3 3.4s3.4 5 3.4 8.3V457c0 3.3-1.1 6-3.4 8.3s-5 3.4-8.3 3.4H140.6c-13 0-24.1-4.6-33.2-13.7l-93.8-93.8c-9-9-13.6-20.1-13.6-33.1s4.6-24.1 13.7-33.2l250-250c9.1-9.1 20.2-13.7 33.2-13.7s24.1 4.6 33.2 13.7l156.3 156.3c9.1 9.1 13.7 20.2 13.7 33.2s-4.7 24.1-13.8 33.2zM140.6 421.9h125l53.7-53.7-156.2-156.3L46.9 328.1l93.7 93.8zM296.9 78.1L196.3 178.7 352.5 335l100.6-100.6L296.9 78.1z"/></svg>');
        opacity: 0;
    }
}

.single-product__compare-btn-disable {
    background-color: #ccc;
    color: #666;
    transition: $dur $ease;
    margin-left: auto;
    pointer-events: none;

    @include mq($xl) {
        margin-left: auto;
        padding: 5px 18px;
    }

    @include mq($md) {
        margin: 0 auto;
        max-width: 100%;
        width: 100%;
    }

    &:hover {
        background-color: #ccc;
        color: #666;
        border: 2px solid #ccc;
    }
}

.product-listing__loader-wrapper-btn {
    margin-top: 35px;
}

.product-listing__header-options-wrapper--left {
    max-width: 84%;
    width: 100%;
    flex-wrap: wrap;
    display: flex;
    align-items: center;

    @include mq($xl) {
        max-width: 100%;
    }

    @include mq($lg) {
        justify-content: space-between;
        align-items: flex-start;
    }

    .product-listing__header-options-outer {
        margin-bottom: 25px;
        margin-right: 14px;
        max-width: 250px;
        width: 100%;

        @include mq(1500px) {
            @include mq(1025px, min) {
                max-width: 26%;
                margin-right: 1%;
            }
        }

        @include mq(1024px) {
            max-width: 48.5%;
            width: 100%;
            margin-right: 3%;

            &:nth-child(2n) {
                margin-right: 0;
            }
        }

        @include mq($md) {
            max-width: 100%;
            margin-right: 0;
            margin-bottom: 15px;

            &:nth-child(2n) {
                margin-right: 0;
            }
        }
    }

    .product-listing__header-options-container,
    .product-listing__header-options--with-img-container {
        width: 100%;

        @include mq($lg) {
            margin-right: 0;
        }
    }
}

.product-listing__header-options-wrapper--right {
    max-width: 16%;
    min-width: 195px;
    width: 100%;

    @include mq($xl) {
        max-width: 100%;
    }

    .product-listing__header-options-container {
        margin-left: auto;
        margin-bottom: 25px;

        @include mq($xl) {
            margin-left: 0;
            margin-bottom: 0;
        }
    }

    .product-listing__header-options-container-title {
        display: block;
        margin-bottom: 3px;
        font-family: $font-main;
        font-size: 14px;
        color: $gray;
        font-weight: 500;
    }
}

.product-listing__pagination {
    .dots {
        pointer-events: none;
    }
}

.product-listing__pagination-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 0 40px;

    &.product-listing__pagination-wrapper--bottom {
        padding: 60px 0;

        @include mq($lap-small) {
            padding: 50px 0;
        }

        @include mq($sm) {
            padding: 30px 0;
        }
    }

    @include mq($lg) {
        flex-direction: column;
    }
}

.product-listing__pagination-view-per-page {
    margin-right: 30px;
    display: flex;
    align-items: center;

    @include mq($lg) {
        margin-right: 0;
        margin-bottom: 10px;
    }

    @include mq($sm) {
        flex-direction: column;
    }
}

.product-listing__pagination-view-text {
    display: block;
    margin-right: 10px;

    span {
        font-weight: 600;
    }

    @include mq($sm) {
        margin-right: 0;
        margin-bottom: 10px;
    }
}

.product-listing__pagination-view-select-box-text {
    display: flex;
    align-items: center;
}

.product-listing__pagination-view-select {
    margin-left: 10px;
}

.pagination-list {
    margin: 0;
    padding: 0;
    text-align: center;

    li {
        display: inline;

        a {
            display: inline-block;
            text-decoration: none;
            padding: 4px 8px;
            color: $black;
            border-radius: 5px;
            transition: $dur $ease;
            font-size: 16px;
            font-weight: 400;
            font-family: $font-main;
            min-width: 25px;
            margin: 0 2px;
            cursor: pointer;
            user-select: none;

            &.active {
                background-color: $theme-green;
                color: $white;
                transition: $dur $ease;
            }

            &:hover:not(.active) {
                transition: $dur $ease;
                background-color: $gray;
                color: $white;
            }

            @include mq($sm) {
                margin: 0 2px;
                padding: 3px 5px;
                font-size: 16px;
            }
        }
    }
}

.product-listing__not-found-wrapper {
    background-color: #f0ede7;
}

.product-listing__not-found {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 60px 30px;
    margin-bottom: 50px;
    text-align: center;

    @include mq($sm) {
        padding: 30px 15px;
    }
}

.product-listing__not-found-title {
    color: $black;
    font-size: 30px;
    font-family: $font-second;
    font-weight: bold;
    line-height: 36px;
    letter-spacing: 0;
    margin-bottom: 30px;

    @include mq($sm) {
        font-size: 24px;
        line-height: 30px;
        margin-bottom: 20px;
    }
}

.product-listing__not-found-text {
    color: $black;
    font-size: 16px;
    letter-spacing: 0;
    font-family: $font-second;
    line-height: 22px;
    margin-bottom: 20px;

    &:last-child {
        margin-bottom: 0;
    }

    @include mq($sm) {
        line-height: 20px;
        font-size: 14px;
        max-width: 180px;
    }
}

.product-listing__not-found-img {
    margin-bottom: 40px;

    @include mq($sm) {
        margin-bottom: 20px;
    }
}

.product-listing__not-found-link {
    text-transform: uppercase;
    color: $black;
    font-size: 14px;
    font-family: $font-second;
    letter-spacing: 0;
    line-height: 22px;
    font-weight: bold;
    display: flex;
    align-items: center;
    transition: $dur $ease;
    margin-top: 30px;

    svg {
        fill: $yellow;
        margin: 10px;
        height: 18px;
        transition: $dur $ease;
    }

    @include hover {
        color: $yellow;
        transition: $dur $ease;

        svg {
            fill: $black;
            transition: $dur $ease;
        }
    }

    @include mq($sm) {
        margin-top: 10px;
    }
}
</style>
